import { useRef } from 'react';
import { swipeStep } from '../lib/swipe';

// Finger swipe between slides. Spread what this returns onto the element the
// reader swipes on:
//
//   const swipe = useSwipe({ onNext, onPrev, enabled });
//   <div {...swipe}>…</div>
//
// The rule for what counts as a swipe is swipeStep() in src/lib/swipe.js.
//
// A swipe is not also a tap. The blocks open an editor on a tap (a hot
// take, a book's reaction), and a swipe across that text must not open it.
// Nothing here has to stop that: a swipe travels at least SWIPE_MIN_PX, and
// the browser sends no click for a touch that moved that far. Checked in
// Chrome with real touch events, including a swipe that starts on "Add a
// reaction...". Not checked on an iPhone.
//
// Only touch. A mouse still uses the arrows and dots. Nothing here calls
// preventDefault on a touch, so scrolling and pinch zoom work as they did.

export function useSwipe({ onNext, onPrev, enabled = true }) {
  const start = useRef(null);
  if (!enabled) return {};
  return {
    onTouchStart(e) {
      // A second finger means a pinch, not a swipe.
      if (e.touches.length !== 1) { start.current = null; return; }
      start.current = { x: e.touches[0].clientX, y: e.touches[0].clientY };
    },
    onTouchEnd(e) {
      const s = start.current;
      start.current = null;
      const t = e.changedTouches?.[0];
      if (!s || !t) return;
      const step = swipeStep(t.clientX - s.x, t.clientY - s.y);
      if (!step) return;
      if (step > 0) onNext(); else onPrev();
    },
    onTouchCancel() { start.current = null; },
  };
}
